'use client';

import { ComponentProps, useMemo } from 'react';
import { useSelector } from 'react-redux';
import logWebHeaderAllTrailsLogoTapped from '@alltrails/amplitude/events/logWebHeaderAllTrailsLogoTapped';
import useUser from '@alltrails/context/hooks/useUser';
import useMediaQuery from '@alltrails/core/hooks/useMediaQuery';
import Link from '@alltrails/denali/components/Link';
import Logo from '@alltrails/denali/components/Logo';
import { BREAKPOINT_MD_SIZE } from '@alltrails/denali/tokens';
import styles from './styles/styles.module.scss';
import { HeaderBackground } from './types';

type LogoLinkProps = {
  background?: HeaderBackground;
};

const LogoLink = ({ background }: LogoLinkProps) => {
  const isMobileBrowser = useSelector((state: { context: { mobileBrowser: boolean } }) => state.context?.mobileBrowser);
  const isSmallerScreen = useMediaQuery(`(max-width: ${BREAKPOINT_MD_SIZE}px)`, isMobileBrowser);

  const user = useUser();

  const logoProps = useMemo<Pick<ComponentProps<typeof Logo>, 'color' | 'variant'>>(() => {
    if (user || isMobileBrowser || isSmallerScreen) {
      return {
        color: background === 'transparent-inverted' ? 'monochrome-light' : 'monochrome-dark',
        variant: 'symbol'
      };
    }
    return {
      color: background === 'transparent-inverted' ? 'colored-light' : 'colored-dark',
      variant: 'logomark'
    };
  }, [background, isMobileBrowser, isSmallerScreen, user]);

  return (
    <div className={styles.focusContainer}>
      <Link
        className={styles.logoLink}
        href="/"
        onClick={() => {
          logWebHeaderAllTrailsLogoTapped();
        }}
      >
        <Logo {...logoProps} size="sm" />
      </Link>
    </div>
  );
};
export default LogoLink;
